import { useTranslate } from "@tolgee/react";
import { AlertTriangle, RotateCw } from "lucide-react";
import { Button } from "#/components/ui/button.tsx";

type ChartErrorProps = {
	onRetry: () => void;
};

export function ChartError({ onRetry }: ChartErrorProps) {
	const { t } = useTranslate();

	return (
		<div className="absolute inset-0 z-10 flex items-center justify-center bg-trade-surface/95 backdrop-blur-sm">
			<div className="flex max-w-xs flex-col items-center gap-3 px-6 text-center">
				<AlertTriangle className="h-8 w-8 text-trade-red" />
				<div className="flex flex-col gap-1">
					<p className="text-label1-medium text-trade-text-strong">
						{t("chart.error.title")}
					</p>
					<p className="text-label2 text-trade-text-secondary">
						{t("chart.error.description")}
					</p>
				</div>
				<Button variant="outline" size="sm" onClick={onRetry} className="mt-1">
					<RotateCw className="h-3.5 w-3.5" />
					{t("state.retry")}
				</Button>
			</div>
		</div>
	);
}
